import React, { useEffect, useState } from 'react'
import Navbar3 from '../../Navbars/Navbar3'
import TMLSubNavbar from '../TMLSubNavbar/TMLSubNavbar'
import Select from "react-select";
import axios from 'axios'
import './TMLSimulator.css'
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Loader from "react-js-loader";
const { REACT_APP_UPLOAD_DATA } = process.env;

const TMLSimulator = () => {
  const [isHover, setIsHover] = useState(false);
  const [isHoverCreate, setIsHoverCreate] = useState(false);
  const [isHoverUpdate, setIsHoverUpdate] = useState(false);
  const monthOrderMap = {
    January: 10,
    February: 11,
    March: 12,
    April: 1,
    May: 2,
    June: 3,
    July: 4,
    August: 5,
    September: 6,
    October: 7,
    November: 8,
    December: 9,
  };
  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa",
    "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
    "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
    "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu and Kashmir",
    "Ladakh", "Puducherry", "Chandigarh", "Andaman and Nicobar Islands",
    "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep"
  ];
  const months = [
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ];
  const fiscalyear = [
    { label: '2025-26', value: '2025-26' }
  ]
  const scenarioTypeOption = [
    { label: 'New Scenario', value: 'New Scenario' },
    { label: 'Old Scenario', value: 'Old Scenario' },
  ]
  const selectAllOption = { value: "*", label: "Select All" };
  
  const customOptions = [
  selectAllOption,
  ...[...months].sort((a, b) => monthOrderMap[a.label] - monthOrderMap[b.label])
];

  const stateOptions = indianStates.map(state => ({ value: state, label: state }));

  const [selectedState, setSelectedState] = useState("");
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedFY, setSlecetdFY] = useState('');
  const [forecastData, setForecastData] = useState([]);
  const [finalForecastDataToUpload, setFinalForecastDataToUpload] = useState([])
  const [scenarioName, setScenarioName] = useState('');
  const [selectedScenarioType, setSelectedScenarioType] = useState('')
  const [tableData, setTableData] = useState([]);
  const [changedDealers, setChangedDealers] = useState(new Set());
  const [oldScenarioNames, setOldScenarioNames] = useState([])
  const [selectedScenarioName, setSlectedScenarioNamse] = useState('')
  const [newSavedScenarioName, setNewSavedScenarioName] = useState('')
  const [optimizeResult, setOptimizeResult] = useState([])
  const [optimizeResultMonthWiseTotal, setOptimizeResultMonthWiseTotal] = useState([])
  const [dealerDetail, setDealerDetail] = useState([])
  const [monthWiseTotalLBBaseScenario, setMonthWiseTotalLBBaseScenario] = useState([])
  const [monthWiseTotalLBScenario, setMonthWiseTotalLBScenario] = useState([])

  // For Optimizer Table Filter Option
  const [filtertedOptimizeResult, setFilteredOptimizeResult] = useState([])
  const [filtertedOptimizeResultMonthWiseTotal, setFilteredsOptimizeResultMonthWiseTotal] = useState([])
  const [selectedFilteredMonths, setSelectedFilteredMonths] = useState([]);
  const [selectedFilteredDealerCode, setSelectedFilteredDealerCode] = useState([]);
  const [dealerCodeList, setDealerCodeList] = useState([])
  const [monthList, setMonthList] = useState([])
  const [recommendData, setRecommendData] = useState([])
  const [currentDealerRecommendDataToShow, setCurrentDealerRecommendDataToShow] = useState('')
  const [errors, setErrors] = useState({});
  // Flags
  const [isFetchingConstraintData, setIsFetchingConstraintData] = useState(false)
  const [showSaveForecastModal, setShowSaveForecastModal] = useState(false)
  const [gettingOptimizedResult, setGettingOptimizedResult] = useState(false)
  const [reciveedOptimizedResult, setrecivedOptimizedResult] = useState(false)
  const [forecastDataSaved, setForecastDataSaved] = useState(false)
  const [forecastValueUpdateFlag, setForecastValueUpdateFlag] = useState(false)
  const [constraintValueUpdateFlag, setconstraintValueUpdateFlag] = useState(false)
  const [updatingForecastValuetoDbFlag, setUpdatingForecastValuetoDbFlag] = useState(false)
  const [updatingConstraintValuetoDbFlag, setUpdatingConstraintValuetoDbFlag] = useState(false)
  const [savingScenarioInDb, setSavingScenarioInDb] = useState(false)
  const [fetchingRecommendData, setFetchingRecommendData] = useState({})
  const [showRecommendDataModal, setShowRecommendDataModal] = useState(false)
  const [showSailenecData, setShowSailenecData] = useState(false)


  const handleApplyFilterBtn = () => {
    // Only Dealer Code are Selected
    if (selectedFilteredDealerCode.length > 0 && selectedFilteredMonths.length === 0) {
      const result = []
      selectedFilteredDealerCode.forEach((code) => {
        const data = optimizeResult.filter((it) => it.Dealer_Code === code.value)
        result.push(...data)
      })
      setFilteredOptimizeResult(result)
    }
    // Only Months are Selected
    else if (selectedFilteredDealerCode.length === 0 && selectedFilteredMonths.length > 0) {
      const result = []
      selectedFilteredMonths.forEach((month) => {
        const data = optimizeResult.filter((it) => it.Fiscal_Month === month.value)
        result.push(...data)
      })
      setFilteredOptimizeResult(result)
      const monthWiseTotalFilterResult = []
      selectedFilteredMonths.forEach((month) => {
        const data = optimizeResultMonthWiseTotal.filter((it) => it.Fiscal_Month === month.value)
        monthWiseTotalFilterResult.push(...data)
      })
      setFilteredsOptimizeResultMonthWiseTotal(monthWiseTotalFilterResult)
    }
    // Both Dealer Code and Month are Selected
    else if (selectedFilteredDealerCode.length > 0 && selectedFilteredMonths.length > 0) {
      const result = []
      const finalResult = []
      selectedFilteredDealerCode.forEach((code) => {
        const data = optimizeResult.filter((it) => it.Dealer_Code === code.value)
        result.push(...data)
      })
      selectedFilteredMonths.forEach((month) => {
        const data = result.filter((it) => it.Fiscal_Month === month.value)
        finalResult.push(...data)
      })
      setFilteredOptimizeResult(finalResult)
      const monthWiseTotalFilterResult = []
      selectedFilteredMonths.forEach((month) => {
        const data = optimizeResultMonthWiseTotal.filter((it) => it.Fiscal_Month === month.value)
        monthWiseTotalFilterResult.push(...data)
      })
      setFilteredsOptimizeResultMonthWiseTotal(monthWiseTotalFilterResult)
    }
    // Clean Up 
    else {
      setFilteredOptimizeResult(optimizeResult)
      setFilteredsOptimizeResultMonthWiseTotal(optimizeResultMonthWiseTotal)
    }
  }


  const handleMonthsSelectChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelectedMonths([]);
      setForecastData([]);
      return;
    }

    let finalSelection = selectedOptions;

    if (selectedOptions.some(opt => opt.value === "*")) {
      finalSelection = months;
    }

    setSelectedMonths(finalSelection);

    const updatedForecastData = finalSelection.map(monthOption => {
      const existing = forecastData.find(item => item.value === monthOption.value);
      return {
        value: monthOption.value,
        month: monthOption.label,
        forecast: existing ? existing.forecast : 0
      };
    });
    const sortedForecastData = [...updatedForecastData].sort((a, b) => monthOrderMap[a.month] - monthOrderMap[b.month])
    setForecastData(sortedForecastData);
  };

  const handleForecastChange = (index, newValue, month) => {
    let sumOfLB = 0
    let match = ''
    if (selectedScenarioType === 'New Scenario') {
      match = monthWiseTotalLBBaseScenario.find(data => data.month === month);
      sumOfLB = match ? match.SumOfLB : 0;
    }
    else {
      match = monthWiseTotalLBScenario.find(data => data.month === month);
      sumOfLB = match ? match.SumOfLB : 0;
    }

    const updatedForecastData = [...forecastData];
    updatedForecastData[index].forecast = newValue;

    const newErrors = { ...errors };

    if (newValue < sumOfLB && newValue != 0) {
      newErrors[index] = `Forecast cannot be below minimum leads in previous years (${sumOfLB})`;
    } else {
      delete newErrors[index];
    }

    setForecastData(updatedForecastData);
    setErrors(newErrors);
  };

  // Constraint table Function

  const fetchConstraint = async () => {
    try {
      setIsFetchingConstraintData(true)
      const response = await axios.get(`${REACT_APP_UPLOAD_DATA}/app/getConstraints`)
      setTableData(response.data.data)
      setMonthWiseTotalLBBaseScenario(response.data.data2)
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
    finally {
      setIsFetchingConstraintData(false)
    }
  }

  const fetchConstraintOfScenario = async () => {
    try {
      setIsFetchingConstraintData(true)
      const config = {
        method: "post",
        url: `${REACT_APP_UPLOAD_DATA}/app/getScenarioConstraints`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: { 'scenario_name': selectedScenarioName }
      };
      const response = await axios(config)
      if (response.status === 200) {
        setTableData(response.data.data)
        setMonthWiseTotalLBScenario(response.data.data2)
        setIsFetchingConstraintData(false)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
  }

  const fetchForecastData = async () => {
    try {
      const config = {
        method: "post",
        url: `${REACT_APP_UPLOAD_DATA}/app/getScenarioForecastData`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: { 'scenario_name': selectedScenarioName, 'state': selectedState, 'fy': selectedFY }
      };
      const response = await axios(config)
      if (response.status === 200) {
        const data = response.data
        const sortedData = [...data].sort((a, b) => monthOrderMap[a.month] - monthOrderMap[b.month])
        setForecastData(sortedData)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
  }

  const fetchScenarioName = async () => {
    try {
      const response = await axios.get(`${REACT_APP_UPLOAD_DATA}/app/getScenarioNames`)
      if (response.status === 200 && response.data.length > 0) {
        const scenarioOptions = response.data.map((it) => { return { 'label': it, 'value': it } })
        setOldScenarioNames(scenarioOptions)
      }
      else if (response.data.length == 0 && response.status == 200) {
        toast.warning('No Old Scenario Are Present')
        setSelectedScenarioType('New Scenario')
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
  }

  const handleInputChange = (dealerIndex, leadIndex, field, value) => {
    const updatedData = [...tableData];
    updatedData[dealerIndex].leadSource[leadIndex][field] = value;
    const updatedChanged = new Set(changedDealers);
    updatedChanged.add(updatedData[dealerIndex].dealerCode);
    setTableData(updatedData);
    setChangedDealers(updatedChanged);
  };

  const handleSaveForecastTableBtn = async () => {
    const currentMonth = new Date().getMonth() + 1; // getMonth() is 0-indexed
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const hasInvalidForecast = forecastData.some(it => {
      return (it.forecast == 0 && it.value >= currentMonth);
    });
    console.log(hasInvalidForecast)
    if (hasInvalidForecast) {
      toast.warning("0 is not allowed for the Months in Forecast Value");
      // handle the error (e.g., block form submit)
    } else {
      const completedForecastData = monthNames.map((monthName, index) => {
        const monthNumber = String(index + 1).padStart(2, '0'); // '01', '02', ..., '12'

        const existing = forecastData.find(it => it.value === monthNumber);

        return existing || {
          value: monthNumber,
          month: monthName,
          forecast: 0
        };
      });
      setFinalForecastDataToUpload(completedForecastData)
      setShowSaveForecastModal(true)
    }
  }

  const handleSaveScenarioBtn = async () => {
    try {
      setSavingScenarioInDb(true)
      console.log(tableData)
      const config = {
        method: "post",
        url: `${REACT_APP_UPLOAD_DATA}/app/modifyConstraints`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: {
          'data': tableData,
          'scenarioName': scenarioName
        }
      };
      const response = await axios(config)
      if (response.status === 200) {
        // toast.success(response.data.message)
        saveForecastDatatoDb()
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          setSavingScenarioInDb(false)
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          setSavingScenarioInDb(false)
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        setSavingScenarioInDb(false)
        toast.error('Server is Down - Check after sometime')
      }
    }
  }

  const saveForecastDatatoDb = async () => {
    try {
      const config = {
        method: "post",
        url: `${REACT_APP_UPLOAD_DATA}/app/saveForecastData`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: {
          'data': finalForecastDataToUpload,
          'scenarioName': scenarioName,
          'state': selectedState,
          'fy': selectedFY
        }
      };
      const response = await axios(config)
      if (response.status === 200) {
        setNewSavedScenarioName(response.data.data)
        toast.success(response.data.message)
        setShowSaveForecastModal(false)
        setForecastDataSaved(true)
        setScenarioName('')
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
    finally {
      setSavingScenarioInDb(false)
    }
  }

  const handleshowOptimizeResultBtn = async () => {
    setGettingOptimizedResult(true)
    try {
      const config = {
        method: "post",
        url: `${REACT_APP_UPLOAD_DATA}/app/optimized`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: {
          scenario_name: selectedScenarioType === 'New Scenario' ? newSavedScenarioName : selectedScenarioName,
          scenario_timestamp: "2025-05-13 11:31:36.899208"
        }

      };
      const response = await axios(config)
      if (response.status === 200) {
        console.log()
        setOptimizeResult(response.data.data)
        setFilteredOptimizeResult(response.data.data)
        setDealerDetail(response.data.dealerDetail)
        setOptimizeResultMonthWiseTotal(response.data.month_total)
        setFilteredsOptimizeResultMonthWiseTotal(response.data.month_total)
        setDealerCodeList(response.data.dealerDetail.map((it) => { return { label: `${it.dealerCode} - ${it.dealerName}`, value: it.dealerCode } }))
        setMonthList(response.data.fiscal_month_list.map((it) => { return { label: it, value: it } }))
        setrecivedOptimizedResult(true)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
    finally {
      setGettingOptimizedResult(false)
    }
  }

  const handleExportToExcel = () => {
    // Group dealer-wise data
    const groupedData = filtertedOptimizeResult.reduce((acc, curr) => {
      if (!acc[curr.Dealer_Code]) acc[curr.Dealer_Code] = [];
      acc[curr.Dealer_Code].push(curr);
      return acc;
    }, {});

    // Prepare Month-wise Total Sheet
    const totalSheetData = filtertedOptimizeResultMonthWiseTotal.map(item => ({
      Fiscal_Month: item.Fiscal_Month,
      ATL_Total: Math.round(Number(item.ATL)),
      BTL_Total: Math.round(Number(item.BTL)),
      Digital_Total: Math.round(Number(item.Digital)),
      TGM_Total: Math.round(Number(item.TGM)),
      Beat_Plan_Total: Math.round(Number(item.Beat_Plan)),
      Total_Leads_Total: Math.round(Number(item.Total_leads)),
      Lead_Conversion_Prediction_Total: Math.round(Number(item.Lead_conversion_prediction)),
    }));

    // Prepare Dealer-wise Optimized Sheet
    const dealerWiseSheetData = [];

    Object.entries(groupedData).forEach(([dealerCode, rows]) => {
      rows.forEach(row => {
        dealerWiseSheetData.push({
          Dealer_Code: dealerCode,
          Fiscal_Month: row.Fiscal_Month,
          ATL: Math.round(Number(row.ATL)),
          BTL: Math.round(Number(row.BTL)),
          Digital: Math.round(Number(row.Digital)),
          TGM: Math.round(Number(row.TGM)),
          Beat_Plan: Math.round(Number(row.Beat_Plan)),
          Total_Leads: Math.round(Number(row.Total_leads)),
          Lead_Conversion_Prediction: Math.round(Number(row.Lead_conversion_prediction))
        });
      });
    });

    // Create workbook and sheets
    const workbook = XLSX.utils.book_new();

    const totalWorksheet = XLSX.utils.json_to_sheet(totalSheetData);
    XLSX.utils.book_append_sheet(workbook, totalWorksheet, 'Month-wise Totals');

    const dealerWiseWorksheet = XLSX.utils.json_to_sheet(dealerWiseSheetData);
    XLSX.utils.book_append_sheet(workbook, dealerWiseWorksheet, 'Dealer-wise Details');

    // Export workbook
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'Optimized_Result.xlsx');
  };

  const handleUpdateForecastvalueBtn = async () => {
    try {
      setUpdatingForecastValuetoDbFlag(true)
      const config = {
        method: "put",
        url: `${REACT_APP_UPLOAD_DATA}/app/updateForecastData`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: {
          'data': forecastData,
          'scenarioName': selectedScenarioName,
          'state': selectedState,
          'fy': selectedFY
        }
      };
      const response = await axios(config)
      if (response.status === 200) {
        toast.success(response.data.message)
        fetchForecastData()
        setUpdatingForecastValuetoDbFlag(false)
        setForecastValueUpdateFlag(false)
        setOptimizeResult([])
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
  }

  const handleUpdateConstraintvalueBtn = async () => {
    try {
      setUpdatingConstraintValuetoDbFlag(true)
      const config = {
        method: "put",
        url: `${REACT_APP_UPLOAD_DATA}/app/updateConstraints`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: {
          'data': tableData,
          'scenarioName': selectedScenarioName
        }
      };
      const response = await axios(config)
      if (response.status === 200) {
        toast.success(response.data.message)
        fetchConstraintOfScenario()
        setUpdatingConstraintValuetoDbFlag(false)
        setconstraintValueUpdateFlag(false)
        setOptimizeResult([])
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
  }

  const getDealerName = (dealerCode) => {
    const dealerName = dealerDetail.find(data => data.dealerCode === dealerCode)?.dealerName;
    return dealerName
  }

  const handleShowRecommend = async (dealerCode) => {
    try {
      setFetchingRecommendData(prev => ({ ...prev, [dealerCode]: true }))
      const config = {
        method: "post",
        url: `${REACT_APP_UPLOAD_DATA}/app/getRecommend`,
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
        data: {
          'dealer_code': dealerCode
        }
      };
      const response = await axios(config)
      if (response.status === 200) {
        setRecommendData(response.data)
        setShowRecommendDataModal(true)
        setCurrentDealerRecommendDataToShow(dealerCode)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(`Server Error : ${error.response.data.detail}`)
        }
        else {
          toast.error(`Server Error : ${error.response.message}`)
        }
      }
      else {
        toast.error('Server is Down - Check after sometime')
      }
    }
    finally {
      setFetchingRecommendData(prev => ({ ...prev, [dealerCode]: false }));
    }
  }

  useEffect(() => {
    setSlectedScenarioNamse('')
    setTableData([])
    setForecastData([])
    setSelectedMonths([])
    setOptimizeResult([])
    setErrors({})
    setForecastDataSaved(false)
    if (selectedScenarioType === 'New Scenario') {
      fetchConstraint()
    }
    else if (selectedScenarioType === 'Old Scenario') {
      fetchScenarioName()
    }

  }, [selectedScenarioType])

  useEffect(() => {
    if (selectedScenarioName != '') {
      fetchConstraintOfScenario()
      fetchForecastData()
    }
    setTableData([])
    setForecastData([])
    setOptimizeResult([])
    setForecastDataSaved(false)
    setErrors({})
  }, [selectedScenarioName])

  useEffect(() => {
    handleApplyFilterBtn()
  }, [selectedFilteredDealerCode, selectedFilteredMonths])

  useEffect(() => {
    setIsFetchingConstraintData(false)
    setShowSaveForecastModal(false)
    setGettingOptimizedResult(false)
    setrecivedOptimizedResult(false)
    setForecastDataSaved(false)
    setForecastValueUpdateFlag(false)
    setconstraintValueUpdateFlag(false)
    setUpdatingConstraintValuetoDbFlag(false)
    setUpdatingForecastValuetoDbFlag(false)
    setSavingScenarioInDb(false)
    setNewSavedScenarioName('')
    setShowRecommendDataModal(false)
    setErrors({})
    setShowSailenecData(false)
  }, [])

  return (
    <>
      {/* Save Forecast Modal */}
      {showSaveForecastModal && (
        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Save Scenario</h5>
                <button type="button" className="btn-close" onClick={() => setShowSaveForecastModal(false)} disabled={savingScenarioInDb}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Enter Scenario Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={scenarioName}
                  onChange={(e) => setScenarioName(e.target.value)}
                  placeholder="Enter the Scenario name"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" onClick={() => setShowSaveForecastModal(false)} disabled={savingScenarioInDb}>Cancel</button>
                <button type="button" className="btn btn-success" onClick={handleSaveScenarioBtn} disabled={scenarioName === ''}>
                  {savingScenarioInDb ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showRecommendDataModal && (
        <div className="modal show  d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content shadow">

              {/* Modal Header */}
              <div className="modal-header text-white align-middle" style={{ backgroundColor: '#19332D' }}>
                <h5 className="modal-title">
                  Recommend Details for <span className="fw-bold">{getDealerName(currentDealerRecommendDataToShow)}</span>
                  <small className="text-light ms-2">(Dealer Code: {currentDealerRecommendDataToShow})</small>
                </h5>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="row">
                  {recommendData.map((cluster, index) => (
                    <div key={index} className="col-md-6 col-lg-4 mb-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-header bg-gradient bg-secondary text-white fw-semibold text-center">
                          {cluster.leadSourceCluster}
                        </div>
                        <div className="card-body p-2">
                          <ul className="list-group list-group-flush">
                            {cluster.leadSource.map((source, idx) => (
                              <li key={idx} className="list-group-item py-1 px-2 d-flex align-items-center small">
                                <i className="bi bi-arrow-right-circle-fill me-2 text-secondary"></i>
                                {source.leadSource}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-danger" onClick={() => setShowRecommendDataModal(false)}>Close</button>
              </div>
            </div >
          </div >
        </div >
      )}
      <Navbar3 />
      <TMLSubNavbar />
      <div className='bgpages'>
        <section className='container-fluid py-3'>
          <div className='px-2 text-secondary small'>{`Dashboard >> Scenario Planner`}</div>

          <div className="px-2 py-3 mb-3 d-flex justify-content-between align-items-center shadow-sm rounded" style={{ backgroundColor: '#ffffff' }}>
            <b className="greentheme m-0" style={{ fontSize: "1.25rem" }}>Lead Source Management Planner</b>
          </div>

          <div className="card px-4 py-4 shadow-sm z-3">
            <div className="row gy-4">
              {/* Select State */}
              <div className="col-12 col-md-3">
                <label className="form-label">
                  Select State: <span className='text-danger'>*</span>
                </label>
                <Select
                  options={stateOptions}
                  value={stateOptions.find(option => option.value === selectedState)}
                  onChange={option => {
                    setSelectedState(option ? option.value : "");
                    setSlecetdFY('');
                    setSelectedMonths([]);
                    setForecastData([])
                    setTableData([])
                    setOptimizeResult([])
                    setSelectedScenarioType('')
                    setSlectedScenarioNamse('')
                    setForecastDataSaved(false)
                  }}
                  classNamePrefix="select"
                  placeholder="Type or select a state..."
                  isClearable
                  isDisabled={reciveedOptimizedResult || forecastDataSaved}
                />
              </div>

              {/* Select Fiscal Year */}
              <div className="col-12 col-md-3">
                <label className="form-label">
                  Select FY: <span className='text-danger'>*</span>
                </label>
                <Select
                  options={fiscalyear}
                  value={selectedFY ? fiscalyear.find(option => option.value === selectedFY) : null}
                  onChange={option => {
                    setSlecetdFY(option ? option.value : '')
                  }}
                  placeholder="Select Fiscal Year"
                  classNamePrefix="select"
                  isDisabled={selectedState === '' || reciveedOptimizedResult || forecastDataSaved}
                />
              </div>


              {/* Select Scenario */}
              <div className="col-12 col-md-3">
                <label className="form-label">
                  Select Scenario <span className='text-danger'>*</span>
                </label>
                <Select
                  options={scenarioTypeOption}
                  value={selectedScenarioType ? scenarioTypeOption.find(option => option.value === selectedScenarioType) : null}
                  onChange={option => {
                    setSelectedScenarioType(option ? option.value : '')
                  }}
                  placeholder="Select Type Of Scenario"
                  classNamePrefix="select"
                  isDisabled={selectedFY === '' || reciveedOptimizedResult || forecastDataSaved}
                />
              </div>

              {/* Select Months */}
              {
                selectedScenarioType == 'New Scenario' &&
                <div className="col-12 col-md-3">
                  <label className="form-label">
                    Select Months: <span className='text-danger'>*</span>
                  </label>
                  <Select
                    options={customOptions}
                    isMulti
                    value={selectedMonths}
                    onChange={handleMonthsSelectChange}
                    placeholder="Select multiple Months"
                    classNamePrefix="select"
                    closeMenuOnSelect={false}
                    isDisabled={reciveedOptimizedResult || forecastDataSaved || isFetchingConstraintData}
                  />
                </div>
              }

              {/* select Scenario Name  */}
              {
                selectedScenarioType === 'Old Scenario' &&
                <div className="col-12 col-md-3">
                  <label className="form-label">
                    Select Scenario <span className='text-danger'>*</span>
                  </label>
                  <Select
                    options={oldScenarioNames}
                    value={selectedScenarioName ? oldScenarioNames.find(option => option.value === selectedScenarioName) : null}
                    onChange={option => {
                      setSlectedScenarioNamse(option ? option.value : '')
                    }}
                    placeholder="Select Scenario Name"
                    classNamePrefix="select"
                    isDisabled={reciveedOptimizedResult}
                  />
                </div>
              }

            </div>
            {
              reciveedOptimizedResult && selectedScenarioType === 'Old Scenario' &&
              <div className="row gy-4 mt-1">
                <div className="col-12 d-flex justify-content-end">
                  <button
                    className="btn"
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    style={{
                      backgroundColor: isHover ? '#145a4f' : '#19332D',
                      color: 'white',
                      transition: 'background-color 0.3s ease, transform 0.2s ease',
                      transform: isHover ? 'scale(1.03)' : 'scale(1)',
                    }}
                    onClick={() => {
                      setrecivedOptimizedResult(false)
                      setTableData([])
                      setSlectedScenarioNamse('')
                      setForecastData([])
                      setOptimizeResult([])
                      setFilteredOptimizeResult([])
                      setSelectedFilteredDealerCode([])
                      setSelectedFilteredMonths([])
                      setDealerCodeList([])
                      setMonthList([])
                    }}
                    disabled={updatingForecastValuetoDbFlag || updatingConstraintValuetoDbFlag}
                  >
                    Modify
                  </button>
                </div>
              </div>
            }

            {
              forecastDataSaved &&
              <div className="row gy-4 mt-1">
                <div className="col-12 d-flex justify-content-end gap-3">
                  <button
                    className="btn"
                    onMouseEnter={() => setIsHoverCreate(true)}
                    onMouseLeave={() => setIsHoverCreate(false)}
                    style={{
                      backgroundColor: isHoverCreate ? '#145a4f' : '#19332D',
                      color: 'white',
                      transition: 'background-color 0.3s ease, transform 0.2s ease',
                      transform: isHoverCreate ? 'scale(1.03)' : 'scale(1)',
                    }}
                    onClick={() => {
                      setSlecetdFY('');
                      setSelectedScenarioType('');
                      setOptimizeResult([]);
                      setForecastData([]);
                      setTableData([]);
                    }}
                  >
                    Create New Scenario
                  </button>

                  <button
                    className="btn"
                    onMouseEnter={() => setIsHoverUpdate(true)}
                    onMouseLeave={() => setIsHoverUpdate(false)}
                    style={{
                      backgroundColor: isHoverUpdate ? '#145a4f' : '#19332D',
                      color: 'white',
                      transition: 'background-color 0.3s ease, transform 0.2s ease',
                      transform: isHoverUpdate ? 'scale(1.03)' : 'scale(1)',
                    }}
                    onClick={() => {
                      setSelectedScenarioType('Old Scenario');
                      setSlectedScenarioNamse(newSavedScenarioName)
                    }}
                  >
                    Update Current Scenario
                  </button>
                </div>
              </div>

            }
          </div>

          {
            isFetchingConstraintData ? (
              <div
                className="row d-flex justify-content-center align-items-center"
                style={{ height: '15vh' }}
              >
                <Loader
                  type="box-rectangular"
                  bgColor="#0A4742"
                  title={selectedScenarioType === 'New Scenario' ? 'Fetching Base Scenario Constraint...' : `Fetching ${selectedScenarioName} Scenario Constraint and Forecast Value...`}
                  color="#0A4742"
                  size={75}
                />
              </div>
            ) :
              <div className="card px-4 py-4 shadow-sm z-2 mt-2" style={{ width: '90%', maxWidth: '1400px', margin: '0 auto' }}>
                {
                  selectedScenarioType === 'New Scenario' &&
                  <b className="greentheme m-0" style={{ fontSize: "1.25rem" }}>Select Forecast Months to proceed</b>
                }
                {/* Constraint Table */}
                {/* {tableData.length > 0 && (
                  <div className="accordion mt-4 d-flex justify-content-center" id="constraintAccordion">
                    <div className="accordion-item" style={{ width: '90%', maxWidth: '1000px' }}>
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button collapsed fw-bold"
                          style={{ backgroundColor: '#19332D', color: '#fff' }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          onClick={() => {
                            if (constraintValueUpdateFlag == true) {
                              setconstraintValueUpdateFlag(false);
                              fetchConstraintOfScenario();
                            }
                          }}
                        >
                          {`Constraint Table - ${selectedScenarioType === 'Old Scenario' ? selectedScenarioName : 'Base Scenario'}`}
                        </button>
                      </h2>

                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse hide px-3 "
                        aria-labelledby="headingOne"
                        data-bs-parent="#constraintAccordion"
                      >
                        {
                          selectedScenarioType === 'Old Scenario' &&
                          <div className="p-2 d-flex justify-content-end">
                            {!constraintValueUpdateFlag && selectedScenarioType === 'Old Scenario' ? (
                              <button
                                className="btn btn-secondary"
                                onClick={() => setconstraintValueUpdateFlag(true)}
                              >
                                Modify Constraint Value
                              </button>
                            ) : (
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-success"
                                  onClick={handleUpdateConstraintvalueBtn}
                                  disabled={updatingConstraintValuetoDbFlag}
                                >
                                  {updatingConstraintValuetoDbFlag ? 'Updating...' : 'Update The Constraint Value'}
                                </button>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => {
                                    setconstraintValueUpdateFlag(false);
                                    fetchConstraintOfScenario();
                                  }}
                                  disabled={updatingConstraintValuetoDbFlag}
                                >
                                  Close
                                </button>
                              </div>
                            )}
                          </div>
                        }
                        {/* <div className="accordion-body p-0 custom-scroll mt-2" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                          <div className="accordion" id="dealerAccordion">
                            {tableData?.map((dealer, dealerIdx) => (
                              <div className="accordion-item mb-3" key={dealer.dealerCode} >
                                <h2 className="accordion-header " id={`dealer-heading-${dealerIdx}`}>
                                  <button
                                    className="constraint accordion-button collapsed fw-bold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#dealer-collapse-${dealerIdx}`}
                                    aria-expanded="false"
                                    aria-controls={`dealer-collapse-${dealerIdx}`}
                                  >
                                    Dealer Code: {dealer.dealerCode} - {dealer.dealerName}
                                  </button>
                                </h2>
                                <div
                                  id={`dealer-collapse-${dealerIdx}`}
                                  className="accordion-collapse collapse p-2"
                                  aria-labelledby={`dealer-heading-${dealerIdx}`}
                                  data-bs-parent="#dealerAccordion"
                                >
                                  <div className="accordion-body p-2">

                                    <div className="accordion" id={`leadAccordion-${dealerIdx}`}>
                                      {Object.entries(
                                        dealer.leadSource.reduce((acc, lead) => {
                                          if (!acc[lead.name]) acc[lead.name] = []
                                          acc[lead.name].push(lead)
                                          return acc
                                        }, {})
                                      ).map(([leadName, leadArray], leadIdx) => (
                                        <div className="accordion-item" key={leadName}>
                                          <h2 className="accordion-header" id={`lead-heading-${dealerIdx}-${leadIdx}`}>
                                            <button
                                              className="constraint accordion-button collapsed"
                                              type="button"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#lead-collapse-${dealerIdx}-${leadIdx}`}
                                              aria-expanded="false"
                                              aria-controls={`lead-collapse-${dealerIdx}-${leadIdx}`}
                                            >
                                              Lead Source: {leadName}
                                            </button>
                                          </h2>
                                          <div
                                            id={`lead-collapse-${dealerIdx}-${leadIdx}`}
                                            className="accordion-collapse collapse"
                                            aria-labelledby={`lead-heading-${dealerIdx}-${leadIdx}`}
                                            data-bs-parent={`#leadAccordion-${dealerIdx}`}
                                          >
                                            <div className="accordion-body p-2">
                                              <div className="table-responsive">
                                                <table className="table table-bordered table-sm text-center align-middle">
                                                  <thead className="table-dark sticky-top z-1">
                                                    <tr>
                                                      <th>Month</th>
                                                      <th>UB</th>
                                                      <th>LB</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {leadArray
                                                      .sort((a, b) => monthOrderMap[a.month] - monthOrderMap[b.month])
                                                      .map((lead, monthIdx) => (
                                                        <tr key={`${monthIdx}-${lead.name}-${lead.month}`}>
                                                          <td>{lead.month}</td>
                                                          <td>
                                                            <input
                                                              type="number"
                                                              className="form-control form-control-sm text-center"
                                                              value={lead?.UB}
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  dealerIdx,
                                                                  dealer.leadSource.findIndex(l => l === lead),
                                                                  'UB',
                                                                  Number(e.target.value)
                                                                )
                                                              }
                                                              disabled={!constraintValueUpdateFlag && selectedScenarioType === 'Old Scenario'}
                                                            />
                                                          </td>
                                                          <td>
                                                            <input
                                                              type="number"
                                                              className="form-control form-control-sm text-center"
                                                              value={lead?.LB}
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  dealerIdx,
                                                                  dealer.leadSource.findIndex(l => l === lead),
                                                                  'LB',
                                                                  Number(e.target.value)
                                                                )
                                                              }
                                                              disabled={!constraintValueUpdateFlag && selectedScenarioType === 'Old Scenario'}
                                                            />
                                                          </td>
                                                        </tr>
                                                      ))}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>

                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div> }

                      </div>
                    </div>
                  </div>
                )} */}

                {/* Forecast Table For New Scenario */}
                {selectedScenarioType === 'New Scenario' && forecastData.length > 0 && (
                  <div className="card px-4 py-4 mt-4 shadow-sm z-2" style={{ width: '90%', maxWidth: '1000px', margin: '0 auto' }}>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                      <h5 className="mb-0 fw-bold"> {(newSavedScenarioName != '' && selectedScenarioType === 'New Scenario') ? `Forecast Table - ${newSavedScenarioName}` : 'Forecast Table'}</h5>
                      {!forecastDataSaved &&
                        <button className='btn'
                          onMouseEnter={() => setIsHover(true)}
                          onMouseLeave={() => setIsHover(false)}
                          style={{
                            backgroundColor: isHover ? '#145a4f' : '#19332D',
                            color: 'white',
                            transition: 'background-color 0.3s ease, transform 0.2s ease',
                            transform: isHover ? 'scale(1.03)' : 'scale(1)'
                          }}
                          onClick={handleSaveForecastTableBtn}
                          disabled={Object.keys(errors).length > 0}
                        >
                          Save Forecast Table
                        </button>
                      }
                    </div>

                    <div className="custom-scroll" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                      <table className="table table-bordered table-striped mb-0 text-center align-middle">
                        <thead className="table-dark sticky-top">
                          <tr>
                            <th style={{ width: '50%' }}>Month</th>
                            <th style={{ width: '50%' }}>Forecast Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {forecastData.map((item, index) => (
                            <tr key={index} style={{ height: '40px' }}>
                              <td>{item.month}</td>
                              <td>
                                <input
                                  type="number"
                                  className={`form-control form-control-sm text-center ${errors[index] ? 'is-invalid' : item.forecast != 0 ? 'is-valid' : ''}`}
                                  value={item.forecast}
                                  onChange={(e) => handleForecastChange(index, Number(e.target.value), item.month)}
                                  min="0"
                                  disabled={monthOrderMap[item.month] < monthOrderMap[new Date().toLocaleString('default', { month: 'long' })] || newSavedScenarioName != ''}
                                />
                                {errors[index] && (
                                  <div className="text-danger small mt-1">{errors[index]}</div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Forecast Table For Old Scenario */}
                {selectedScenarioType === 'Old Scenario' && selectedScenarioName !== '' && forecastData.length > 0 && (
                  <div className="accordion mt-4" style={{ width: '90%', maxWidth: '1000px', margin: '0 auto' }} id="forecastAccordion">
                    <div className="accordion-item shadow-sm z-2">
                      <h2 className="accordion-header" id="forecastHeading">
                        <button
                          className="accordion-button collapsed fw-bold"
                          type="button"
                          style={{ backgroundColor: '#19332D', color: '#fff' }}
                          onClick={() => {
                            if (forecastValueUpdateFlag === true) {
                              setForecastValueUpdateFlag(false)
                              fetchForecastData()
                            }
                          }}
                          id='togglebtnforecasttable'
                          data-bs-toggle="collapse"
                          data-bs-target="#forecastCollapse"
                          aria-expanded="false"
                          aria-controls="forecastCollapse"
                          disabled={updatingForecastValuetoDbFlag}
                        >
                          {`Forecast Value Of - ${selectedScenarioType === 'Old Scenario' ? selectedScenarioName : 'Base Scenario'}`}
                        </button>
                      </h2>
                      <div
                        id="forecastCollapse"
                        className="accordion-collapse collapse"
                        aria-labelledby="forecastHeading"
                        data-bs-parent="#forecastAccordion"
                      >
                        <div className="p-2 d-flex justify-content-end">
                          {!forecastValueUpdateFlag ? (
                            <button
                              className="btn btn-secondary"
                              onClick={() => setForecastValueUpdateFlag(true)}
                            >
                              Modify Forecast Value
                            </button>
                          ) : (
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-success"
                                onClick={handleUpdateForecastvalueBtn}
                                disabled={updatingForecastValuetoDbFlag || Object.keys(errors).length > 0}
                              >
                                {updatingForecastValuetoDbFlag ? 'Updating...' : 'Update The Forecast Value'}
                              </button>
                              <button
                                className="btn btn-danger"
                                onClick={() => {
                                  setForecastValueUpdateFlag(false);
                                  fetchForecastData();
                                }}
                                disabled={updatingForecastValuetoDbFlag}
                              >
                                Close
                              </button>
                            </div>
                          )}
                        </div>

                        <div className="accordion-body px-4 py-2">
                          <div className="custom-scroll" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            <table className="table table-bordered table-striped mb-0 text-center align-middle">
                              <thead className="table-dark sticky-top">
                                <tr>
                                  <th style={{ width: '50%' }}>Month</th>
                                  <th style={{ width: '50%' }}>Forecast Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {forecastData.map((item, index) => {
                                  return (<tr key={index} style={{ height: '40px' }}>
                                    <td>{item.month}</td>
                                    <td>
                                      <input
                                        type="number"
                                        className={`form-control form-control-sm text-center ${errors[index] ? 'is-invalid' : item.forecast != 0 ? 'is-valid' : ''}`}
                                        value={item.forecast}
                                        onChange={(e) => handleForecastChange(index, Number(e.target.value), item.month)}
                                        min="0"
                                        disabled={monthOrderMap[item.month] < monthOrderMap[new Date().toLocaleString('default', { month: 'long' })] || !forecastValueUpdateFlag}
                                      />
                                      {errors[index] && (
                                        <div className="text-danger small mt-1">{errors[index]}</div>
                                      )}
                                    </td>
                                  </tr>)
                                }

                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Optimize Button for Old Scenario */}
                {(selectedScenarioType === 'Old Scenario' && selectedScenarioName !== '' && forecastData.length > 0 && optimizeResult.length === 0) &&
                  <div className='d-flex justify-content-center mt-4'>
                    <button className='btn'
                      onMouseEnter={() => setIsHover(true)}
                      onMouseLeave={() => setIsHover(false)}
                      style={{
                        backgroundColor: isHover ? '#145a4f' : '#19332D',
                        color: 'white',
                        transition: 'background-color 0.3s ease, transform 0.2s ease',
                        transform: isHover ? 'scale(1.03)' : 'scale(1)'
                      }}
                      onClick={handleshowOptimizeResultBtn}
                      disabled={gettingOptimizedResult || forecastValueUpdateFlag || constraintValueUpdateFlag}
                    >
                      {gettingOptimizedResult ? 'fetching....' : 'Show Optimize Result'}
                    </button>
                  </div>
                }

                {/* Optimize Button for New Scenario */}
                {(selectedScenarioType === 'New Scenario' && forecastDataSaved && forecastData.length > 0 && optimizeResult.length === 0) &&
                  <div className='d-flex justify-content-center mt-4'>
                    <button className='btn'
                      onMouseEnter={() => setIsHover(true)}
                      onMouseLeave={() => setIsHover(false)}
                      style={{
                        backgroundColor: isHover ? '#145a4f' : '#19332D',
                        color: 'white',
                        transition: 'background-color 0.3s ease, transform 0.2s ease',
                        transform: isHover ? 'scale(1.03)' : 'scale(1)'
                      }}
                      onClick={handleshowOptimizeResultBtn}
                      disabled={gettingOptimizedResult}
                    >
                      {gettingOptimizedResult ? 'fetching....' : 'Show Optimize Result'}
                    </button>
                  </div>
                }
              </div>
          }

          {/* Optimize result table */}
          {
            optimizeResult.length > 0 && (
              <div className="card px-4 py-4 mt-4 shadow-sm z-2" style={{ width: '90%', maxWidth: '1400px', margin: '0 auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 fw-bold">{`Optimized Result For ${selectedScenarioName}`}</h5>
                  <button
                    className="btn"
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    style={{
                      backgroundColor: isHover ? '#145a4f' : '#19332D',
                      color: 'white',
                      transition: 'background-color 0.3s ease, transform 0.2s ease',
                      transform: isHover ? 'scale(1.03)' : 'scale(1)'
                    }}
                    onClick={handleExportToExcel}
                  >
                    Export to Excel
                  </button>
                </div>
                {/* Filter Section   */}
                <div className="z-3 row g-3 align-items-center mb-3">
                  <div className="col-12 col-md-6">
                    <Select
                      options={dealerCodeList}
                      isMulti
                      isSearchable
                      placeholder="Filter w.r.t Dealer Code(s)"
                      value={selectedFilteredDealerCode}
                      onChange={(selectedOptions) => {
                        setSelectedFilteredDealerCode(selectedOptions)
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <Select
                      options={monthList}
                      isMulti
                      isSearchable
                      placeholder="Filter w.r.t Month(s)"
                      value={selectedFilteredMonths}
                      onChange={(selectedOptions) => {
                        setSelectedFilteredMonths(selectedOptions)
                      }}
                    />
                  </div>
                </div>

                <div className="z-2 accordion" id="optimizedDataAccordion">
                  {/* Accordion Item 1: Month-wise Total */}
                  <div className="accordion-item mb-3">
                    <h2 className="accordion-header" id="headingTotal">
                      <button
                        className="accordion-button collapsed fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTotal"
                        aria-expanded="false"
                        aria-controls="collapseTotal"
                        style={{ backgroundColor: '#19332D', color: '#fff' }}
                      >
                        Month-wise Optimized Totals
                      </button>
                    </h2>
                    <div id="collapseTotal" className="accordion-collapse collapse show" aria-labelledby="headingTotal" >
                      <div className="p-2 d-flex justify-content-end">
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowSailenecData(prev => !prev)}
                        >
                          {showSailenecData ? `Show Month-Wise Total Data` : `Show Salience Data`}
                        </button>
                      </div>
                      <div className="accordion-body custom-scroll" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <table className="table  table-striped text-center align-middle mb-0">
                          <thead className="table-dark sticky-top">
                            <tr>
                              <th>Fiscal Month</th>
                              <th>ATL</th>
                              <th>BTL</th>
                              <th>Digital</th>
                              <th>TGM</th>
                              <th>Beat Plan</th>
                              {!showSailenecData && <th>Total_Leads</th>}
                              <th>Lead Conversion Prediction</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...filtertedOptimizeResultMonthWiseTotal].sort((a,b)=>monthOrderMap[a.Fiscal_Month]-monthOrderMap[b.Fiscal_Month]).map((item, subIndex) => {
                              if (showSailenecData) {
                                return (
                                  <tr key={`total-${subIndex}`}>
                                    <td>{item.Fiscal_Month}</td>
                                    <td>{Math.round(Number(item.ATL_Salience))}%</td>
                                    <td>{Math.round(Number(item.BTL_Salience))}%</td>
                                    <td>{Math.round(Number(item.Digital_Salience))}%</td>
                                    <td>{Math.round(Number(item.TGM_Salience))}%</td>
                                    <td>{Math.round(Number(item.Beat_Plan_Salience))}%</td>
                                    <td>{Math.round(Number(item.Lead_conversion_prediction_Salience))}%</td>
                                  </tr>
                                )
                              }
                              else {
                                return (
                                  <tr key={`total-${subIndex}`}>
                                    <td>{item.Fiscal_Month}</td>
                                    <td>{Math.round(Number(item.ATL))}</td>
                                    <td>{Math.round(Number(item.BTL))}</td>
                                    <td>{Math.round(Number(item.Digital))}</td>
                                    <td>{Math.round(Number(item.TGM))}</td>
                                    <td>{Math.round(Number(item.Beat_Plan))}</td>
                                    <td>{Math.round(Number(item.Total_leads))}</td>
                                    <td>{Math.round(Number(item.Lead_conversion_prediction))}</td>
                                  </tr>
                                )
                              }
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Accordion Item 2: Detail Data */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingDetails">
                      <button
                        className="accordion-button collapsed fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseDetails"
                        aria-expanded="false"
                        aria-controls="collapseDetails"
                        style={{ backgroundColor: '#19332D', color: '#fff' }}
                      >
                        Dealer-wise Optimized Details
                      </button>
                    </h2>
                    <div id="collapseDetails"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingDetails"
                    >
                      <div className="accordion-body custom-scroll" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <table className="table table-striped text-center align-middle mb-0 mt-0">
                          <thead className="table-dark sticky-top">
                            <tr>
                              <th>Fiscal Month</th>
                              <th>ATL</th>
                              <th>BTL</th>
                              <th>Digital</th>
                              <th>TGM</th>
                              <th>Beat Plan</th>
                              {!showSailenecData && <th>Total_Leads</th>}
                              <th>Lead Conversion Prediction</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(
                              filtertedOptimizeResult.reduce((acc, curr) => {
                                if (!acc[curr.Dealer_Code]) acc[curr.Dealer_Code] = [];
                                acc[curr.Dealer_Code].push(curr);
                                return acc;
                              }, {})
                            ).map(([dealerCode, dealerRows]) => (
                              <React.Fragment key={dealerCode}>
                                <tr className="table-secondary fw-bold">
                                  <td colSpan="8" className="px-3 py-2">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                      <div className="fw-semibold text-dark">
                                        Dealer Code: <b><span className="text-danger">{dealerCode}</span></b> - {getDealerName(dealerCode)}
                                      </div>
                                      <button
                                        className="btn btn-sm btn-outline-danger mt-2 mt-md-0"
                                        onClick={() => handleShowRecommend(dealerCode)}
                                        disabled={fetchingRecommendData[dealerCode]}
                                      >
                                        {fetchingRecommendData[dealerCode] ? 'Grabbing...' : 'Show Recommend'}
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                                {[...dealerRows].sort((a,b)=>monthOrderMap[a.Fiscal_Month]-monthOrderMap[b.Fiscal_Month]).map((item, subIndex) => {
                                  if (!showSailenecData) {
                                    return (
                                      <tr key={`${dealerCode}-${subIndex}`}>
                                        <td>{item.Fiscal_Month}</td>
                                        <td>{Math.round(Number(item.ATL))}</td>
                                        <td>{Math.round(Number(item.BTL))}</td>
                                        <td>{Math.round(Number(item.Digital))}</td>
                                        <td>{Math.round(Number(item.TGM))}</td>
                                        <td>{Math.round(Number(item.Beat_Plan))}</td>
                                        <td>{Math.round(Number(item.Total_leads))}</td>
                                        <td>{Math.round(Number(item.Lead_conversion_prediction))}</td>
                                      </tr>
                                    )
                                  }
                                  else {
                                    return (
                                      <tr key={`${dealerCode}-${subIndex}`}>
                                        <td>{item.Fiscal_Month}</td>
                                        <td>{Math.round(Number(item.ATL_Salience))}%</td>
                                        <td>{Math.round(Number(item.BTL_Salience))}%</td>
                                        <td>{Math.round(Number(item.Digital_Salience))}%</td>
                                        <td>{Math.round(Number(item.TGM_Salience))}%</td>
                                        <td>{Math.round(Number(item.Beat_Plan_Salience))}%</td>
                                        <td>{Math.round(Number(item.Lead_conversion_prediction_Salience))}%</td>
                                      </tr>
                                    )
                                  }
                                })}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </section>
      </div>

    </>
  );
};

export default TMLSimulator;
